module.exports = __webpack_public_path__ + "static/media/right_side_picture.68ea19c5.jpg";